import './Result.css'
import { Link, useLocation } from "react-router-dom";

export default function Result () {
    
    const location = useLocation();
    const { speed, time } = location.state || {};

    console.log(speed, time);

    return (
        <div className="result-wrapper">
            <h1 className='title'>typing test completed!</h1>
            <div className='info'>you typed <strong>{time} {time === 1 ? 'minute' : 'minutes'} typing test.</strong></div>
            <div className='result'>your speed was <span>{speed}<small>WPM</small></span></div>
            <Link to='/' className='btn'>Take again</Link>
        </div>
    )
} 